export default __webpack_public_path__ + "static/media/rec3.7efe2f9f.svg";